import { redirect, type LoaderFunctionArgs } from 'react-router';

import {
  loadRwPageSession,
  type RegulatoryWatchSessionPageId,
} from './hooks/regulatoryWatchPageSession';

/**
 * Applies saved Regulatory Watch list query params before the route renders so hooks
 * never see an empty URL on the first paint (avoids flash of default filters).
 */
export function regulatoryWatchListLoader(
  pageId: RegulatoryWatchSessionPageId
) {
  return ({ request, params }: LoaderFunctionArgs) => {
    const workspaceUname = params.workspaceUname;
    if (!workspaceUname || typeof workspaceUname !== 'string') {
      return null;
    }

    const url = new URL(request.url);
    if (url.searchParams.toString() !== '') {
      return null;
    }

    const session = loadRwPageSession(workspaceUname, pageId);
    if (session?.dirty && session.search) {
      url.search = session.search;
      return redirect(`${url.pathname}${url.search}${url.hash}`);
    }

    return null;
  };
}
